/**
 * @file src/hooks/useRouteHistory.ts
 * @exports useRouteHistory
 * @summary Tracks the previous URL using TanStack Router navigation lifecycle events.
 */

import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAtom } from "jotai";
import { previousPathAtom } from "src/shame/shame-atoms";

export const useRouteHistory = () => {
	const router = useRouter();
	const [previousPath, setPreviousPath] = useAtom(previousPathAtom);

	useEffect(() => {
		return router.subscribe("onBeforeNavigate", ({ fromLocation }) => {
			if (!fromLocation) {
				return;
			}
			setPreviousPath(
				`${fromLocation.pathname}${fromLocation.searchStr ?? ""}${fromLocation.hash ? `#${fromLocation.hash}` : ""}`,
			);
		});
	}, [router, setPreviousPath]);

	return {
		previousPath,
	};
};
